import { render, staticRenderFns } from "./MainPact.vue?vue&type=template&id=37a4980f"
import script from "./MainPact.vue?vue&type=script&lang=js"
export * from "./MainPact.vue?vue&type=script&lang=js"
import style0 from "./MainPact.vue?vue&type=style&index=0&id=37a4980f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports